import {
    HandHistoryListRequest,
    HandHistoryListResponse,
    HistoricHandWrapper,
    HandHistoryDownloadResponse
} from "../../../../generated/protocol";
import {injectable, inject} from "inversify";
import {HttpService, HTTP_SERVICE_NAME} from "../../http/HttpService";

export interface HandHistoryService {
    listHandHistory(req: HandHistoryListRequest): Promise<HandHistoryListResponse>;

    getHand(id: String): Promise<HistoricHandWrapper>;

    downloadHandHistory(req: HandHistoryListRequest): Promise<HandHistoryDownloadResponse>;

    bulkDownloadHandHistory(req: HandHistoryListRequest): Promise<HandHistoryDownloadResponse>;
}

@injectable()
export class HandHistoryServiceImpl implements HandHistoryService {

    http: HttpService;

    getHand(id: string): Promise<HistoricHandWrapper> {
        return this.http.doGet("/poker/hand-history/hand/" + id);
    }

    constructor(@inject(HTTP_SERVICE_NAME) http: HttpService) {
        this.http = http;
    }

    listHandHistory(req: HandHistoryListRequest): Promise<HandHistoryListResponse> {
        return this.http.doPost("/poker/hand-history/list", req);
    }

    downloadHandHistory(req: HandHistoryListRequest): Promise<HandHistoryDownloadResponse> {
        return this.http.doPost("/poker/hand-history/download", req);
    }

    bulkDownloadHandHistory(req: HandHistoryListRequest): Promise<HandHistoryDownloadResponse> {
        return this.http.doPost("/poker/hand-history/bulk-download", req);
    }
}


// WEBPACK FOOTER //
// ./src/app/service/poker/history/HandHistoryService.tsx